import { memo } from 'react'

function EmptyTableContent({ text }) {
  return (
    <h2
      className={
        'text-center py-6 text-lg font-normal text-gray-500 dark:text-amber-50 dark:bg-slate-800'
      }
    >
      {text}
    </h2>
  )
}

export default memo(EmptyTableContent)
